import { ROUTES_NAMES } from '@/constants';
import { beforeEnterForgotPasswordRoute } from './forgotPasswordNavigationGuards';
import { RouteRecordRaw } from 'vue-router';
import ForgotPasswordPanel from '@/views/ForgotPassword.vue';

const forgotPasswordRoute: RouteRecordRaw = {
  path: '/forgotpassword',
  name: ROUTES_NAMES.forgotPassword,
  component: ForgotPasswordPanel,
  beforeEnter: beforeEnterForgotPasswordRoute
};

export default forgotPasswordRoute;
